export default __webpack_public_path__ + "static/media/745750811080aa5e.cec7f0f82fa916d983ba2b3e1b552657.svg";